<template>
  <li :id="$attrs['id']" :class="[{'item-nav__collapsible--open': visibleGroup}, {'item-nav__li--active': active}]" class="item-nav__li item-nav__hr item-nav__collapsible">
    <div class="item-nav__link" @click="onClickGroup">
      <span class="item-nav__link__label" v-html="label"></span>
      <transition-collapse>
        <ul v-show="visibleGroup" class="item-nav__group">
          <slot />
        </ul>
      </transition-collapse>
    </div>
  </li>
</template>

<script>

import { isNil } from 'lodash';

export default {
  name: 'ItemNavGroup',

  props: ['label', 'open', 'active'],

  data() {
    return {
      visibleGroup: this.open,
    };
  },

  watch: {
    open: function (newVal, oldVal) {
      if (newVal === true && newVal !== oldVal) {
        this.visibleGroup = true;
      }
    },
  },

  methods: {
    onClickGroup($event) {
      const closest = $event.target.closest('.item-nav__group');
      if (isNil(closest)) {
        this.visibleGroup = !this.visibleGroup;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
  @import '~styles/components/lib/ItemNav';

</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/ItemNavGroup.vue